const CatalogueEnum = {
    STANDARD: 'Standard',
    NONSTANDARD: 'Non Standard',
    SECONDARY: 'Secondary',
  };
  
  export default CatalogueEnum;